import {Component, Input} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from "angularx-social-login";

@Component({
    selector: 'my-app-sidenav-menu',
    styles: [],
    template: require('./sidenav-menu.component.html')
})

export class AppSidenavMenuComponent {

    role:string = ""
    constructor(private router: Router, private authService: AuthService){

        let user:any = localStorage.getItem("user");
        if(user==null || user ==""){
            this.role = "ADMIN";
        }else{
            user = JSON.parse(user);
            this.role = user.role;
        }
    }

    logoutUser(){
        localStorage.clear();
        this.authService.signOut();
        this.router.navigate(['/extra/login']);
    }

   
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.ts